import React, {useEffect, useState} from 'react';
import axios from '../Common/axios';
import { useParams } from 'react-router-dom';
import {Layout, Button, Modal, Spin} from "antd";
import VaAssetList from './VaAssetList';
import AssetInfo from './AssetInfo';
import Summary from './Summary';
import Item from './Item';
import {getDashBoardReportList, getFindAssetInfo, getFindReportIdInfo, getFindAssetStatistics, getPdfDownload, getPdfDownloadAsset} from '../Common/api';
import {Chart01} from './Chart';
import {getGridTableHeight,isEmpty} from '../Common/util';
import DownloadUrl from '../../components/DownloadUrl';
import {DownloadMd} from '../../components/DownloadPdf';
import MarkdownViewer from '../../components/MarkdownViewer';
import { useEventSource } from '../Common/useEventSource';
// import DownloadPdf from '../../components/DownloadPdf';
// import { jsPDF } from "jspdf";
// import html2canvas from "html2canvas";

const {Sider} = Layout;

function AssetReport() {
    const params = useParams();
    const reportId = params.reportId;
    const loadDefaultMessage = "Loading...";
    const [loadMessage, setLoadMessage] = useState(loadDefaultMessage);
    // const assetCd = params.assetCd;
    // 변수 선언

    // const [reportId, setReportId] = useState(!isEmpty(params.reportId)?params.reportId:'');
    // const [assetCd, setAssetCd] = useState(!isEmpty(params.assetCd)?params.assetCd:'');
    const [assetCd, setAssetCd] = useState('');
    const [companyCode, setCompanyCode] = useState(!isEmpty(params.companyCode)?params.companyCode:'');
    const [assetType, setAssetType] = useState(!isEmpty(params.assetType)?params.assetType:'');
    const [reportName, setReportName] = useState('');

    const [assetInfo, setAssetInfo] = useState([]);
    const [itemList, setItemList] = useState([]);
    const [measureList, setMeasureList] = useState([]);
    const [spinflag, setSpinflag] = useState(true);
    const [markdownVisible, setMarkdownVisible] = useState(false);
    const [markdownContent, setMarkdownContent] = useState('');
    const [sumData, setSumData] = useState({total : 0, check : 0, Y : 0, Yed : 0, N : 0, P : 0, NA : 0, total_score : 0, eval_score : 0, level : 0});
    const spinMask =0;
    const autoDisplay = isEmpty(params.assetCd)?'show':'none';
    
    useEffect(() => {
        findAssetReportInfo();
    }, [assetCd]);
    
    useEffect(() => {
        setAssetCd(params.assetCd);
    }, [params.assetCd]);

    useEffect(() => {
        findReportInfo();
    }, [reportId]);

    useEffect(() => {
        let s_data = {total : 0, check : 0, Y : 0, N : 0, P : 0, NA : 0, total_score : 0, eval_score : 0, level : 0};
        
        measureList.map(curr => {
            s_data.total = s_data.total + curr.total;
            s_data.check = s_data.check + curr.check;
            s_data.Y = s_data.Y + curr.Y;
            s_data.N = s_data.N + curr.N;
            s_data.P = s_data.P + curr.P;
            s_data.NA = s_data.NA + curr.NA;
            s_data.total_score = s_data.total_score + curr.total_score;
            s_data.eval_score = s_data.eval_score + curr.eval_score;
            return s_data;
        });
        s_data.level = s_data.total_score > 0 ? (s_data.eval_score / s_data.total_score) * 100 : 0;
        setSumData(s_data);
      }, [measureList]);

    const findReportInfo = () => {
        // 레포트 조회
        setSpinflag(true);
        if(!isEmpty(reportId)) {
            axios.get(getFindReportIdInfo(reportId))
            .then((response) => {
                setAssetType(response.data[0].asset_type);
                setReportName(response.data[0].report_nm);
            })
            .catch((error) => {
                setAssetType('');
                setReportName('');
            })
            .finally(() => {
                setSpinflag(false);
            });
        } else {
            // 보고서ID가 없는 경우 가장 최근 보고서ID 조회
            axios.get(getDashBoardReportList(companyCode, assetType))
            .then((response) => {
                if(response.data.length > 0) {
                    // 가장 최근 보고서로 세팅
                    // setReportId(response.data[0].report_id);
                    reportId=response.data[0].report_id;
                    setReportName(response.data[0].report_nm);
                    setAssetType(response.data[0].asset_type);
                } else {
                    Modal.info({ title:titleName, content:"해당 자산에 대한 취약점분석 결과가 없습니다."});                    return;
                }
            })
            .catch((error) => {
                setReportName('');
                setAssetType('');
            })
            .finally(() => {
                setSpinflag(false);
            });
        }

        // 자산 초기화
        // setAssetInfo({});
        // setItemList([]);
        // setMeasureList([]);

        //통계 조회
        // if(!isEmpty(reportId) && !isEmpty(assetCd)) {
        //     axios.get(getFindAssetStatistics(reportId, assetCd))
        //     .then((response) => {
        //         //console.log(response);
        //         setItemList(response.data.statistic_root);
        //         setMeasureList(response.data.statistic_measure);
        //     })
        //     .catch((error) => {
        //         console.log("AssetReport.js --- 121 error");
        //         console.dir(error);
        //     });
        // }
    }

    const findAssetReportInfo = () => {
        // 레포트 조회
        // setSpinflag(true);
        // if(!isEmpty(reportId)) {
        //     axios.get(getFindReportIdInfo(reportId))
        //     .then((response) => {
        //         //console.log(response);
        //         setAssetType(response.data[0].asset_type);
        //         setReportName(response.data[0].report_nm);
        //     })
        //     .catch((error) => {
        //         console.log("AssetReport.js --- 67 error");
        //         console.dir(error);
        //     })
        //     .finally(() => {
        //         setSpinflag(false);
        //     });
        // } else {
        //     // 보고서ID가 없는 경우 가장 최근 보고서ID 조회
        //     axios.get(getDashBoardReportList(companyCode, assetType))
        //     .then((response) => {
        //         //console.log(response);
        //         if(response.data.length > 0) {
        //             // 가장 최근 보고서로 세팅
        //             // setReportId(response.data[0].report_id);
        //             reportId=response.data[0].report_id;
        //             setReportName(response.data[0].report_nm);
        //             setAssetType(response.data[0].asset_type);
        //         } else {
        //             Modal.error({title: "해당 자산에 대한 취약점분석 결과가 없습니다."});
        //             return;
        //         }
        //     })
        //     .catch((error) => {
        //         console.log("AssetReport.js --- 89 error");
        //         console.dir(error);
        //     })
        //     .finally(() => {
        //         setSpinflag(false);
        //     });
        // }

        setSpinflag(true);
        // 자산 조회
        if(!isEmpty(assetCd) && !isEmpty(reportId)) {
            axios.get(getFindAssetInfo(reportId, assetCd))
            .then((response) => {
                if(response.data.length > 0) {
                    setAssetInfo(response.data[0]);
                }
            }).catch((error) => {
                // setAssetInfo([]);
                // setSpinflag(false);
            }).finally(() => {
                // setSpinflag(false);
            });
        }


        //통계 조회
        if(!isEmpty(reportId) && !isEmpty(assetCd)) {
            axios.get(getFindAssetStatistics(reportId, assetCd))
            .then((response) => {
                setItemList(response.data.statistic_root.sort((a, b) => 
                    a.measure_type.localeCompare(b.measure_type)
                ));
                setMeasureList(response.data.statistic_measure);
            }).catch((error) => {
                setItemList([]);
                setMeasureList([]);
            }).finally(() => {
                setSpinflag(false);
            });
        }
    }

    // 닫기
    const onClickCloseHandler = () => {
        window.close();
    }

    // 자산 클릭
    const onClickAssetHandler = (assetCd) => {
        setAssetCd(assetCd);
    }

    //PDF다운로드

    const pdfDownLoadReport = (event) =>{

        setSpinflag(true);
        setLoadMessage("잠시만 기다려 주세요. 보고서 작성중 입니다...");
        
        const buttonType = event.currentTarget.textContent;
        let titleName="보고서 생성";

        if (buttonType === 'Markdown') {
            axios.get(getPdfDownload("asset_md", reportId, assetCd)).then((response) => {
                setMarkdownContent(response.data);
                setMarkdownVisible(true);
                setSpinflag(false);
            }).catch((error) => {
                Modal.error({title:titleName,content:"Markdown 생성 중에 에러가 발생하였습니다.", okText:"Close"});
                setSpinflag(false);
            });  
        }else{
            axios.get(getPdfDownloadAsset("asset", reportId, assetCd)).then((response) => {
                console.dir(response);
                if(response.data.status_url){
                    DownloadUrl(response.data.status_url,
                        () => { 
                            setSpinflag(false); // onSuccess
                            setLoadMessage(loadDefaultMessage);
                        },
                        (errorMessage) => {
                            Modal.info({ title:titleName, content:errorMessage, okText: "Close" });
                            setSpinflag(false);
                            setLoadMessage(loadDefaultMessage);
                        }
                    );
                }else{
                    Modal.info({ title:titleName, content:"다운로드 중에 에러가 발생하였습니다.", okText: "Close" });
                    setSpinflag(false);
                    setLoadMessage(loadDefaultMessage);
                }
            }).catch((error) => {
                Modal.error({ title:titleName, content:error.message, okText: "Close" });
                setSpinflag(false);
                setLoadMessage(loadDefaultMessage);
            });   
        }  
       
        // axios.get(getPdfDownloadAsset("asset", reportId, assetCd), { responseType: 'blob' }).then((response) => {
        //     DownloadPdf(response.data, reportId, assetCd+"_상세진단")
        // })
        // .catch((error) => {
        //     console.dir(error);
        //     alert("다운로드 중에 에러가 발생하였습니다.");
        // })
        // .finally( () =>{
        //     setSpinflag(false);
        // });        
    }

    // const pdfDownload = () => {

    //     const report = document.getElementById('report');
    //     const data = document.getElementById('divToPrint');
    //     const div_height = data.style.height;
    //     data.style.height = data.scrollHeight + 'px';

    //     html2canvas(report).then((canvas) => {
    //         const margin = 6; // 출력 페이지 여백설정
    //         const imgWidth = 198;  // 208
    //         const pageHeight = 295;
    //         const imgHeight = (canvas.height * imgWidth) / canvas.width;
    //         let heightLeft = imgHeight;
    //         let position = margin;
    //         heightLeft -= pageHeight;
    //         const doc = new jsPDF('p', 'mm', 'a4');
    //         doc.addImage(canvas, 'PNG', margin, position, imgWidth, imgHeight, '', 'FAST');
    //         while (heightLeft >= 0) {
    //             position = heightLeft - imgHeight;
    //             doc.addPage();
    //             doc.addImage(canvas, 'PNG', margin, position, imgWidth, imgHeight, '', 'FAST');
    //             heightLeft -= pageHeight;
    //         }
    //         doc.save('AssetReport_'+assetCd+'.pdf');
    //     });
    //     //높이 재조정
    //     data.style.height = div_height;
    // };
    return (
        <Spin size={"large"} style={{top:"200px",left:"2%"}} tip={loadMessage} spinning={spinflag}>
        <Layout>
            <Sider style={{backgroundColor:'#fff', display:autoDisplay}}>
                <VaAssetList reportId={reportId} assetType={assetType} reportName={reportName} onClickAsset={onClickAssetHandler} autoDisplay={autoDisplay}/>
            </Sider>
            <Layout id="report" style={{overflow: 'hidden'}}>
                <div className='popup_header'>
                    <div className='popup_title'>
                        {assetInfo?.asset_nm} 상세 진단 결과
                    </div>
                </div>
                <div className="popup_button_report" style={{top: '10px'}}>
                <Button
                        type="default"
                        onClick={pdfDownLoadReport}
                        style={{marginLeft: '10px'}}
                        data-html2canvas-ignore="true"
                    >
                        {'Markdown'}
                </Button>
                    <Button
                        type="default"
                        onClick={pdfDownLoadReport}
                        style={{marginLeft: '10px'}}
                        data-html2canvas-ignore="true"
                    >
                        {'보고서'}
                    </Button>
                    <Button
                        type="default"
                        onClick={onClickCloseHandler}
                        style={{marginLeft: '10px'}}
                        data-html2canvas-ignore="true"
                    >
                        {'닫기'}
                    </Button>
                </div>
                <div id="divToPrint" style={{height:getGridTableHeight(70), overflowY:'auto'}}>
                <div className="section">
                    <table className='search'>
                        <colgroup>
                            <col style={{width:'10%'}} />
                            <col style={{width:'15%'}} />
                            <col style={{width:'10%'}} />
                            <col style={{width:'30%'}} />
                            <col style={{width:'10%'}} />
                            <col style={{width:'15%'}} />
                        </colgroup>
                        <tbody>
                        <tr>
                            <th>자산구분</th>
                            <td>{assetType}</td>
                            <th>취약점분석명</th>
                            <td>{reportName}</td>
                            <th>취약점분석ID</th>
                            <td>{reportId}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div className="section">
                    <table>
                        <colgroup>
                            <col style={{width:'300px'}} />
                            <col />
                        </colgroup>
                        <tr>
                            <td valign='top'>
                                <div className="section">
                                    <AssetInfo assetInfo={assetInfo}/>
                                </div>
                            </td>
                            <td valign='top'>
                                <div className="section">
                                    <Summary measureList={measureList} sumData={sumData}/>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td colSpan={2} align='center'>
                                <div className="section" style={{width:'1200px'}}>
                                    <Chart01 dataList={measureList} sumData={sumData} />
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td colSpan={2}>
                                <div className="section">
                                    <Item itemList={itemList}/>
                                </div>
                            </td>
                        </tr>
                    </table>
                </div>
                </div>
            </Layout>
        </Layout>
        <MarkdownViewer 
            visible={markdownVisible}
            onClose={() => setMarkdownVisible(false)}
            markdownContent={markdownContent}
            reportId={reportId}
            reportName={reportName}
        />
        </Spin>
    );
}

export default AssetReport;